import { concat, fn, hash } from '@ember/helper';
import didInsert from '@ember/render-modifiers/modifiers/did-insert';

import { t } from 'ember-intl';

import { SCANNER_TYPES } from 'umg-ember-backend/components/record-detail/forms/a11y-scanner';
import Component from 'umg-ember-backend/components/record-explorer';
import Table from 'umg-ember-backend/components/record-explorer/table';
import Toolbar from 'umg-ember-backend/components/record-explorer/toolbar';
import Pagination from 'umg-ember-backend/components/ui/pagination';
import Window from 'umg-ember-backend/components/ui/window';

export default class RecordExplorerForA11yScannerComponent extends Component {
  // Defaults
  availableFilters = [
    {
      key: 'type',
      type: 'selectValueLabel',
      options: SCANNER_TYPES,
    },
    {
      key: 'country',
      type: 'selectRelationship',
      recordType: 'category',
      valueKey: 'shortName',
      useLocaleFilter: true,
      queryParams: {
        'filter[type]': 'COUNTRY',
        'sort[name]': 'ASC',
      },
    },
    {
      key: 'recurringScan',
      type: 'selectValueLabel',
      options: [true, false],
    },
  ];

  defaultColumns = [
    'domain',
    'type',
    'recurringScan',
    'scanInterval',
    'activeScan.violationsA',
    'activeScan.violationsAA',
    'activeScan.violationsAAA',
    'activeScan.violationsTotal',
    'activeScan.scoreTotal',
    'activeScan.statusLabel',
  ];

  tableColumns = [
    {
      property: 'id',
      sortable: true,
    },
    {
      property: 'domain',
      sortable: true,
      isMainColumn: true,
    },
    {
      isLinkDisabled: true,
      property: 'activeScan.violationsA',
      relationLabel: 'violationsA',
      relationProperty: 'activeScan',
      type: 'relation',
    },
    {
      isLinkDisabled: true,
      property: 'activeScan.violationsAA',
      relationLabel: 'violationsAA',
      relationProperty: 'activeScan',
      type: 'relation',
    },
    {
      isLinkDisabled: true,
      property: 'activeScan.violationsAAA',
      relationLabel: 'violationsAAA',
      relationProperty: 'activeScan',
      type: 'relation',
    },
    {
      isLinkDisabled: true,
      property: 'activeScan.violationsTotal',
      relationLabel: 'violationsTotal',
      relationProperty: 'activeScan',
      type: 'relation',
    },
    {
      isLinkDisabled: true,
      property: 'activeScan.scoreTotal',
      relationLabel: 'scoreTotal',
      relationProperty: 'activeScan',
      type: 'relation',
    },
    {
      property: 'type',
      type: 'translate-value',
      sortable: true,
    },
    {
      property: 'recurringScan',
      type: 'translate-value',
    },
    {
      property: 'scanInterval',
      type: 'translate-value',
    },
    {
      isLinkDisabled: true,
      property: 'activeScan.statusLabel',
      relationLabel: 'statusLabel',
      relationProperty: 'activeScan',
      type: 'relation',
    },
    {
      property: 'cmsModified',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
    {
      property: 'cmsCreated',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
  ];

  // Template
  // We need to overwrite the default template, because a11y-report are not allowed to duplicate or delete
  <template>
    <Window
      @isBottombarVisible={{if this.recordsData.length true false}}
      @isLoading={{this.loadRecords.isRunning}}
      @isSeamless={{true}}
      @onBodyScroll={{this.setScrollPosition}}
      @scrollPosition={{this.scrollPosition}}
      {{didInsert this.setOrLoadRecords}}
    >
      <:title>
        {{t (concat 'models.plurals.' this.recordType)}}
      </:title>

      <:toolbar>
        <Toolbar
          @activeColumns={{this.activeColumns}}
          @activeFilters={{this.activeFilters}}
          @availableFilters={{this.availableFilters}}
          @columns={{this.tableColumns}}
          @recordType={{this.recordType}}
          @onAddRecord={{this.addRecord}}
          @onAssignRelation={{@onAssignRelation}}
          @onSearch={{this.search}}
          @onSetFilter={{this.setFilter}}
          @parentRecordType={{@parentRecordType}}
          @searchString={{this.searchString}}
          @selectedRecords={{this.selectedRecords}}
        />
      </:toolbar>

      <:body>
        <Table
          @activeSort={{this.activeSort}}
          @columns={{this.visibleColumns}}
          @records={{this.recordsData}}
          @recordType={{this.recordType}}
          @recordActions={{hash
            edit=this.loadRecord
            duplicate=this.duplicateRecord
          }}
          @selectedRecords={{this.selectedRecords}}
          @onAssignRelation={{@onAssignRelation}}
          @onUpdateSort={{fn this.setFilter 'sort'}}
          @onSelectRecord={{this.selectRecord}}
        />
      </:body>

      <:bottombar>
        <Pagination
          @pagination={{this.records.meta}}
          @setPage={{this.setPage}}
          @setPageLimit={{fn this.setFilter 'pageSize'}}
        />
      </:bottombar>
    </Window>
  </template>
}
